import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Calendar, Tag, ArrowRight } from "lucide-react";
import { Badge } from "../components/ui/badge";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/blog`).then(res => setPosts(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-16 h-16 border-4 border-neon-cyan border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen py-10 px-6" data-testid="blog-page">
      <div className="max-w-5xl mx-auto">
        <Badge className="bg-neon-cyan/20 text-neon-cyan border-neon-cyan/50 mb-4">News & Updates</Badge>
        <h1 className="font-heading text-3xl md:text-5xl uppercase tracking-tight mb-10">The Blog</h1>

        {posts.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-zinc-500">No posts yet. Check back soon!</p>
          </div>
        ) : (
          <div className="grid gap-8">
            {posts.map((post) => (
              <Link
                key={post.post_id}
                to={`/blog/${post.slug}`}
                className="glass p-0 overflow-hidden group flex flex-col md:flex-row"
                data-testid={`blog-post-${post.post_id}`}
              >
                {post.image_url && (
                  <div className="md:w-80 h-48 md:h-auto flex-shrink-0 overflow-hidden">
                    <img
                      src={post.image_url}
                      alt={post.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                )}
                <div className="p-6 flex-1 flex flex-col justify-between">
                  <div>
                    <h2 className="font-heading text-xl md:text-2xl uppercase tracking-tight mb-3 group-hover:text-neon-cyan transition-colors">
                      {post.title}
                    </h2>
                    <p className="text-zinc-400 text-sm line-clamp-3 mb-4">{post.excerpt}</p>
                    <div className="flex flex-wrap gap-2 mb-4">
                      {post.tags?.map((tag, i) => (
                        <Badge key={i} variant="outline" className="text-xs border-white/10">
                          <Tag className="w-3 h-3 mr-1" />{tag}
                        </Badge>
                      ))}
                    </div>
                  </div>
                  <div className="flex items-center justify-between text-xs text-zinc-500">
                    <div className="flex items-center gap-2">
                      <Calendar className="w-3 h-3" />
                      {new Date(post.created_at).toLocaleDateString()}
                      <span>by {post.author_name}</span>
                    </div>
                    <span className="text-neon-cyan flex items-center gap-1 group-hover:gap-2 transition-all">
                      Read more <ArrowRight className="w-3 h-3" />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogPage;
